import { useEffect, useRef, useState } from "react";

import { SubmitButton as Button } from "~/components/form/submit-button";
import { getAllTemplates } from "~/services/supervisor.services";
import AddTemplate from "./modals/add-template";
import TemplatesTable from "./table";
import LoadingIcon from "~/components/form/LoadingIcon";

export default function TemplatesComponent() {
  const [templates, setTemplates] = useState<any>(null);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [editData, setEditData] = useState<any>(null);

  const tableRef = useRef<any>(null); // Create a ref for TemplatesTable

  const handleDeleteTemplate = () => {
    if (tableRef.current) {
      tableRef.current.DeleteSelectedRows(); // Call DeleteSelectedRows function on the ref
    }
  };

  const handleAddTemplate = () => {
    setEditData(null);
    setIsOpen(!isOpen);
  };
  const handleEditTemplate = (data: any) => {
    setIsOpen(true);
    setEditData(data);
  };

  useEffect(() => {
    void (async () => {
      const { data, status } = await getAllTemplates();
      if (status) {
        setTemplates((data as any)?.data);
      }
    })();
  }, []);

  return (
    <div className="h-full">
      <div className="mb-2 flex justify-between items-center">
        <h1 className="text-2xl font-semibold text-orange-500">Extraction Learning Module</h1>
        <div className="flex space-x-2">
          <Button type="button" size={"small"} onClick={handleAddTemplate}>
            Add Template
          </Button>
          <Button type="button" size={"small"} onClick={handleDeleteTemplate} >
            Delete
          </Button>
        </div>
      </div>
      {templates != null ? (
        <div>
          <TemplatesTable ref={tableRef} data={templates} onEdit={handleEditTemplate}  />
        </div>
      ) : <LoadingIcon />}
      <AddTemplate
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        mode={editData ? "edit" : "add"}
        data={editData}
      />
    </div>
  );
}
